import React, { useState } from 'react';
import { X } from 'lucide-react';
import { updateProfile } from './authApi.jsx';
import './authModal.scss';
import './editProfileModal.scss';

// ویرایشِ پروفایل: نام، نام خانوادگی و بیوگرافی. onSaved(user) با اطلاعاتِ تازه از سرور
const BIO_MAX = 300;
const fa = (n) => Number(n).toLocaleString('fa-IR');

function EditProfileModal({ user, onClose, onSaved }) {
  const [firstName, setFirstName] = useState(user?.firstName || '');
  const [lastName, setLastName] = useState(user?.lastName || '');
  const [bio, setBio] = useState(user?.bio || '');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!firstName.trim() || !lastName.trim()) {
      setError('نام و نام خانوادگی را وارد کنید');
      return;
    }
    setBusy(true);
    setError('');
    try {
      const updated = await updateProfile({ firstName, lastName, bio });
      onSaved?.(updated);
    } catch (err) {
      setError(err.message);
      setBusy(false);
    }
  };

  return (
    <div className="auth-modal">
      <div className="auth-modal__backdrop" onClick={busy ? undefined : onClose} />
      <div className="auth-modal__sheet">
        <div className="auth-modal__header">
          <h2>ویرایش پروفایل</h2>
          <button type="button" className="auth-modal__close" onClick={onClose} aria-label="بستن" disabled={busy}>
            <X size={20} strokeWidth={1.8} />
          </button>
        </div>

        <form className="auth-modal__form" onSubmit={handleSubmit}>
          <label className="auth-modal__field">
            <span>نام</span>
            <input type="text" value={firstName} maxLength={40} onChange={(e) => setFirstName(e.target.value)} disabled={busy} />
          </label>
          <label className="auth-modal__field">
            <span>نام خانوادگی</span>
            <input type="text" value={lastName} maxLength={40} onChange={(e) => setLastName(e.target.value)} disabled={busy} />
          </label>
          <label className="auth-modal__field">
            <span>بیوگرافی</span>
            <textarea
              className="edit-profile__bio"
              value={bio}
              rows={4}
              maxLength={BIO_MAX}
              placeholder="مثلاً: مشاور املاک | تهران، سعادت‌آباد — خرید، فروش و رهن و اجاره"
              onChange={(e) => setBio(e.target.value)}
              disabled={busy}
            />
            <small className="edit-profile__count">
              {fa(bio.length)} / {fa(BIO_MAX)}
            </small>
          </label>

          {error && <p className="auth-modal__error">{error}</p>}

          <button type="submit" className="auth-modal__submit" disabled={busy}>
            {busy ? 'در حال ذخیره…' : 'ذخیره'}
          </button>
        </form>
      </div>
    </div>
  );
}

export default EditProfileModal;
